import { Component, OnInit, Input, SimpleChanges } from '@angular/core';
import { UtilService } from '../service/util.service';
import { Constants } from '../constants/constants';
import { ApiService } from '../service/api.service';
import { AuthenticationService } from '../service/authentication.service';
import { ToastService } from '../service/toast.service';

@Component({
  selector: 'app-view-service-usage',
  templateUrl: './view-service-usage.component.html',
  styleUrls: ['./view-service-usage.component.scss']
})
export class ViewServiceUsageComponent implements OnInit {

  @Input() usageData: Array<any>;
  @Input() remoteServicesApiReqPayload: { fromDate: Date; toDate: Date; serviceNames: any; };
  remoteServicesApiResponse: any;
  @Input() locationMap: Map<string, any>;

  sortType = ["DESCENDING", "ASCENDING"];
  columns = ["requestStartTime", "correlationId", "vin", "userId", "serviceName", "requestType", "operationStatus"];
  serviceNames = ["ACCOUNT_SERVICE_PACKAGE_PROVISIONING", "VEHICLE_ONBOARDING", "VEHICLE_SERVICE_PACKAGE_PROVISIONING", "USER_ONBOARDING", "REMOTE_SERVICES"];
  remoteServiceNames = ["TELEMATICS_LOCATION", "REMOTE_DOOR_UNLOCK", "REMOTE_DOOR_LOCK", "REMOTE_DOOR", "REMOTE_LIGHT", "REMOTE_HORN", "REMOTE_HORN_LIGHT", "REMOTE_ENGINE", "GEOFENCE_MONITORING", "VEHICLE_MILEAGE", "VEHICLE_FUEL_STATUS", "VEHICLE_TIRE_PRESSURE", "VEHICLE_HEALTH_STATUS", "VEHICLE_LOCK_STATUS"];
  accountOnboardingServiceNames = ["API_KEY_GENERATED", "ACCOUNT_UPDATED", "ACCOUNT_SUBGROUP_DELETED", "ACCOUNT_SUBGROUP_ADDED", "TNC_ACCEPTED"];
  displayNameMap = new Map([["API_KEY_GENERATED", "API Key Generated"], ["API_KEY_RESET", "API Key Reset"], ["API_KEY_REVOKED", "API Key Revoked"], ["TNC_ACCEPTED", "Terms & Conditions Accepted"]]);
  tableSelectedSortOptions: Array<Array<string>>;

  accountOnboardingData: Array<any> = new Array<any>();
  accountServicePackageProvisioningData: Array<any> = new Array<any>();
  vehicleOnboardingData: Array<any> = new Array<any>();
  vehicleServicePackageProvisioningData: Array<any> = new Array<any>();
  userOnboardingData: Array<any> = new Array<any>();
  usageUiData: Array<any> = new Array<any>();
  currentPageRemoteServices: Array<any> = new Array<any>();

  packageMessageMapping: Map<string, string> = new Map<string, string>([
    ["CREATE", "Package Added"],
    ["DELETE", "Package Deleted"],
    ["UPDATE", "Package Updated"]
  ]);
  account: any = {};
  IS_HIDE_USAGE_DETAILS = Constants.IS_HIDE_USAGE_DETAILS;
  
  curPage: number = 0;
  pageSize: number = 100;
  totalPages: number;
  nextPage: number;
  prevPage: number;
  totalCount: number;
  pagesFetched: Array<number> = [];

  infiniteScrollThrottle = 5;
  infiniteScrollDistance = 1;
  
  constructor(
    public utilService: UtilService,
    private apiService: ApiService,
    private authService: AuthenticationService,
    private toast: ToastService
  ) {
    this.account = this.utilService.selectedRentalFleetAccount;
  }
  
  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges) {
    this.initTableSelectedSortOptions();
    this.prepareUIData();

    // condition added to allow method to get called only when remoteServicesApiReqPayload date has proper values    
    let isPageLoadedOrPeriodChanged = this.remoteServicesApiReqPayload && changes.remoteServicesApiReqPayload && !changes.remoteServicesApiReqPayload.firstChange ? true : false;
    if (isPageLoadedOrPeriodChanged) {
      this.remoteServicesApiReqPayload.serviceNames = this.remoteServiceNames;
      this.pagesFetched = [];
      this.curPage = 0;
      this.usageUiData = [];
      this.getRemoteServices();
    }
  }

  initTableSelectedSortOptions() {
    this.tableSelectedSortOptions = [
      [this.serviceNames[0], this.columns[0], this.sortType[0]],
      [this.serviceNames[1], this.columns[0], this.sortType[0]],
      [this.serviceNames[2], this.columns[0], this.sortType[0]],
      [this.serviceNames[3], this.columns[0], this.sortType[0]],
      [this.serviceNames[4], this.columns[0], this.sortType[0]]
    ];
  }

  initUsageData() {
    this.accountServicePackageProvisioningData = new Array<any>();
    this.vehicleOnboardingData = new Array<any>();
    this.vehicleServicePackageProvisioningData = new Array<any>();
    this.userOnboardingData = new Array<any>();
    this.accountOnboardingData = new Array<any>();
  }
  
  initRemoteServicesUsageData() {
    this.usageUiData = new Array<any>();
  }

  prepareUIData() {
    if (this.usageData == null) return;
    this.initUsageData();
    this.sortByDate(this.sortType[0], this.columns[0], this.usageData);
    console.log("Preparing ui data: usageData is: ", this.usageData);
    for (let i = 0; i < this.usageData.length; i++) {
      let usage = this.usageData[i];

      // filter usage data (invoice related)
      if (usage.serviceName == 'BILLING_INITIATED' || usage.serviceName == 'INVOICE_PUBLISHED' || usage.serviceName == 'PAYMENT') continue;
      // TODO: added filter vehicle service package provisioning (temporarily)
      if (usage.serviceName == 'VEHICLE_SERVICE_PACKAGE_PROVISIONING') continue;

      if (usage.interimActions && usage.interimActions.length > 0) {
        this.sortStringVal(this.sortType[1], "operation", usage.interimActions)
      }

      if (usage.vehicleLocationDetail && usage.vehicleLocationDetail.homeLocationId) {
        usage['homeLocation'] = this.locationMap.get(usage.vehicleLocationDetail.homeLocationId);
      }

      if (usage.origin && usage.origin.toLowerCase() == "spam") {
        usage.origin = "Postman";
      }


      if (this.accountOnboardingServiceNames.includes(usage.serviceName)) {
        this.accountOnboardingData.push(usage)
      } else if (usage.serviceName == this.serviceNames[0]) {
        this.accountServicePackageProvisioningData.push(usage);
      } else if (usage.serviceName == this.serviceNames[3]) {
        this.userOnboardingData.push(usage);
      } /* else if (this.remoteServiceNames.includes(usage.serviceName)) {
        this.usageUiData.push(usage);
      } */

      // if (['DEALER', 'CORPORATE'].includes(this.account.category)) {
      // if (this.doesAccountSupportsDongle()) {
        if (usage.serviceName == this.serviceNames[1]) {
          this.vehicleOnboardingData.push(usage);
        } else if (usage.serviceName == this.serviceNames[2]) {
          this.vehicleServicePackageProvisioningData.push(usage);
        }
      // }

    }
    // this.usageData.forEach(usage => {
    //   if(usage.interimActions && usage.interimActions.length > 0) {
    //     this.sortStringVal(this.sortType[1], "operation", usage.interimActions)
    //   }

    //   if(usage.vehicleLocationDetail && usage.vehicleLocationDetail.homeLocationId) {
    //     usage['homeLocation'] = this.locationMap.get(usage.vehicleLocationDetail.homeLocationId);
    //   }

    //   if(usage.serviceName == this.serviceNames[0]) {
    //     this.accountServicePackageProvisioningData.push(usage);
    //   } else if(usage.serviceName == this.serviceNames[1]) {
    //     this.vehicleOnboardingData.push(usage);
    //   } else if(usage.serviceName == this.serviceNames[2]) {
    //     this.vehicleServicePackageProvisioningData.push(usage);
    //   } else if(usage.serviceName == this.serviceNames[3]) {
    //     this.userOnboardingData.push(usage);
    //   } else {
    //     this.usageUiData.push(usage);
    //   }
    // });
  }

  prepareUsageUiData() {
    if (this.remoteServicesApiResponse == null) return;
    let tempUsageUiData = JSON.parse(JSON.stringify(this.usageUiData));
    for (let i = 0; i < this.currentPageRemoteServices.length; i++) {
      let usage = this.currentPageRemoteServices[i];

      // filter usage data (invoice related)
      if (usage.serviceName == 'BILLING_INITIATED' || usage.serviceName == 'INVOICE_PUBLISHED' || usage.serviceName == 'PAYMENT') continue;
      // TODO: added filter vehicle service package provisioning (temporarily)
      if (usage.serviceName == 'VEHICLE_SERVICE_PACKAGE_PROVISIONING') continue;

      if (usage.interimActions && usage.interimActions.length > 0) {
        this.sortStringVal(this.sortType[1], "operation", usage.interimActions)
      }

      if (usage.vehicleLocationDetail && usage.vehicleLocationDetail.homeLocationId) {
        usage['homeLocation'] = this.locationMap.get(usage.vehicleLocationDetail.homeLocationId);
      }

      if (usage.origin && usage.origin.toLowerCase() == "spam") {
        usage.origin = "Postman";
      }

      if (this.remoteServiceNames.includes(usage.serviceName)) {
        tempUsageUiData.push(usage);
      }

      // if (['DEALER', 'CORPORATE'].includes(this.account.category)) {
      // if (this.doesAccountSupportsDongle()) {
        if (usage.serviceName == this.serviceNames[1]) {
          this.vehicleOnboardingData.push(usage);
        } else if (usage.serviceName == this.serviceNames[2]) {
          this.vehicleServicePackageProvisioningData.push(usage);
        }
      // }
    }
    
    this.sortByDate(this.sortType[0], this.columns[0], tempUsageUiData);
    // using tempUsageUiDatabefore instead of this.usageUiData directly to avoid auto calling scroll function indefinitely
    this.usageUiData = JSON.parse(JSON.stringify(tempUsageUiData));
  }

  onSortByDateClick(usageData: [], selectedTable: string, selectedColumn: string) {
    console.log("sort by date clicked:: for table::", selectedTable);

    var sortType = this.getSortType(selectedTable, selectedColumn);
    console.log("sortType::", sortType);
    this.sortByDate(sortType, selectedColumn, usageData);
    this.updateTableSelectedSortOption(selectedTable, selectedColumn, sortType);
  }

  onSortByStringClick(usageData: [], selectedTable: string, selectedColumn: string) {
    console.log("sort clicked:: for table::", selectedTable, ":: for column::", selectedColumn);

    var sortType = this.getSortType(selectedTable, selectedColumn);
    this.sortStringVal(sortType, selectedColumn, usageData);
    this.updateTableSelectedSortOption(selectedTable, selectedColumn, sortType);
  }

  getSortType(selectedTable: string, selectedColumn: string) {
    var selectedSortType = null;

    var index = this.tableSelectedSortOptions.findIndex(item => { return item[0] === selectedTable; });
    if (index >= 0) {
      var tableSortOption = this.tableSelectedSortOptions[index];
      selectedSortType = tableSortOption[2];
      var lastSelectedSortColumn = tableSortOption[1];
      if (lastSelectedSortColumn == selectedColumn) {
        if (selectedSortType == this.sortType[0]) {
          selectedSortType = this.sortType[1];
        } else {
          selectedSortType = this.sortType[0];
        }
      }
    }
    return selectedSortType == null ? this.sortType[0] : selectedSortType;
  }

  updateTableSelectedSortOption(selectedTable: string, selectedColumn: string, sortType: string) {
    var index = this.tableSelectedSortOptions.findIndex(item => { return item[0] == selectedTable; });
    var tableSortOption = this.tableSelectedSortOptions[index];
    tableSortOption[1] = selectedColumn;
    tableSortOption[2] = sortType;
    console.log("tableSelectedSortOptions after update::", this.tableSelectedSortOptions);
  }

  sortStringVal(sortType: string, fieldName: string, usageData) {
    let that = this;
    usageData = usageData.sort(function (a, b) {
      var val1 = "";
      var val2 = "";
      if (a[fieldName] != undefined && a[fieldName] != null) {
        val1 = a[fieldName].toLowerCase();
      }
      if (b[fieldName] != undefined && b[fieldName] != null) {
        val2 = b[fieldName].toLowerCase();
      }
      if (sortType == that.sortType[0]) {
        if (val1 < val2) return -1;
        if (val1 > val2) return 1;
        return 0;
      } else {
        if (val1 > val2) return -1;
        if (val1 < val2) return 1;
        return 0;
      }
    });
  }

  sortByDate(sortType: string, fieldName: string, usageData) {
    let that = this;
    usageData = usageData.sort(function (a, b) {
      if (sortType == that.sortType[0]) {
        return <any>new Date(b[fieldName]) - <any>new Date(a[fieldName]);
      } else {
        return <any>new Date(a[fieldName]) - <any>new Date(b[fieldName]);
      }
    });
  }

  getNotificationAction(notificationActions: Array<any>) {
    if (notificationActions == null || notificationActions == undefined) return null;
    var index = notificationActions.findIndex(notification => notification.operationStatus && notification.operationStatus === "SUCCESS");
    if (index < 0) {
      index = notificationActions.findIndex(notification => notification.operationStatus && notification.operationStatus === "FAILED");
    }
    if (index < 0) {
      index = notificationActions.findIndex(notification => notification.operationStatus && notification.operationStatus === "PENDING");
    }
    if (index < 0) return null;
    return notificationActions[index];
  }

  getPackageMessage(command) {
    var message = command;
    if (command == undefined || command == null) {
      message = "-";
    } else {
      message = this.packageMessageMapping.get(command);
      if (message == undefined || message == null) {
        message = command;
      }
    }
    return message;
  }

  allEmailNotification(usages) {
    if (usages && usages.length > 0) {
      if (usages.length == this.getEmailData(usages)) {        
        console.log("allEmailNotification() returned true");
        return true;
      }
    }
    console.log("allEmailNotification() returned false");
    return false;
  }

  getEmailData(usages) {
    var count = 0;
    for (var i = 0; i < usages.length; i++) {
      if (usages[i].serviceName == 'EMAIL_NOTIFICATION') {
        count++;
      }
    }
    return count;
  }

  getUserOnboardingAction(usage) {
    let action = "User Onboarding";

    if (usage.method == "POST") {
      return "Add User";
      // if (usage.statusCode == '200') {
      //   action = "User Added";
      // } else if (usage.statusCode == '400') {
      //   action = "User Not Added";
      // }
    } else if (usage.method == "DELETE") {
      return "Delete User";
      // if (usage.statusCode == '200') {
      //   action = "User Deleted";
      // } else {
      //   action = "User Not Deleted"
      // }
    } else if (usage.method == "PUT") {
      return "Update User";
    }
    return action;
  }

  doesAccountSupportsDongle() {
    if (this.utilService.doesAccountSupportsDongle(this.account.category)) {
      return true;
    }
    return false;
  } 

  getRemoteServices() {
    this.utilService.showSpinner();
    this.apiService.getRemoteServices(this.remoteServicesApiReqPayload, this.curPage, this.pageSize).then((data) => {
      this.utilService.hideSpinner();
      console.log("Remote Services data::", data);
      this.remoteServicesApiResponse = data;
      this.updatePaginationParams();
      this.pagesFetched.push(this.curPage);
      this.currentPageRemoteServices = this.remoteServicesApiResponse && Array.isArray(this.remoteServicesApiResponse.usageDataRecords) ? this.remoteServicesApiResponse.usageDataRecords : [];
      this.prepareUsageUiData();
    }).catch((error) => {
      console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.getRemoteServices();
        });
      }
      else {
        this.utilService.hideSpinner();
        if (error && error.error && error.error.message) this.toast.showError(error.error.message);
        else this.toast.showError(Constants.UNKNOWN_ERROR);
      }
    });
  }

  onScrollDown() {
    console.log('Scrolled down!');
    if (this.curPage < this.totalPages - 1) {
      this.curPage++;
      // convert this.pagesFetched to set and back to array to avoid duplicates
      this.pagesFetched = Array.from(new Set(this.pagesFetched));
      if (!this.pagesFetched.includes(this.curPage)) {
        this.getRemoteServices();
      }
    }
  }

  updatePaginationParams() {
    this.totalPages = this.remoteServicesApiResponse && this.remoteServicesApiResponse.totalPages || 0;
    this.pageSize = this.remoteServicesApiResponse && this.remoteServicesApiResponse.pageSize || 0;
    this.curPage = this.remoteServicesApiResponse && this.remoteServicesApiResponse.curPage || 0;
    this.nextPage = this.remoteServicesApiResponse && this.remoteServicesApiResponse.nextPage || 0;
    this.prevPage = this.remoteServicesApiResponse && this.remoteServicesApiResponse.prevPage || 0;
    this.totalCount = this.remoteServicesApiResponse && this.remoteServicesApiResponse.totalCount || 0;
  }
}